import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { BenefitWizardType } from "src/app/constants/wizard-panels";

import { BenefitSummaryList } from "src/app/models/benefit-summary";
import { EnrollmentManagerService } from "src/app/services/enrollment-manager.service";

@Component({
    selector: 'mwp-benefit-enrollment-wizard-summary',
    templateUrl: './summary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SummaryComponent implements OnInit {
    @Input() public summaryList: BenefitSummaryList;
	@Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();
    
    public showSummary: boolean;
	public isTermWizard: boolean;
    public showSummaryTotal: boolean;
    public summaryHeader: string;


	constructor(
		private enrollmentManagerService: EnrollmentManagerService,
	){
	}

    ngOnInit(){ 
		this.isTermWizard = this.enrollmentManagerService.benefitWizardControlPanel.wizardType == BenefitWizardType.Term;
		this.showSummaryTotal = this.summaryList.showSummaryTotal || this.summaryList.showCafeteriaSummaryTotal;

        if (this.showSummaryTotal ) {
			if (this.summaryList.showSummaryTotal && this.summaryList.summaryTotalCards[0])
				this.summaryHeader = this.summaryList.summaryTotalCards[0]?.frequencyDisplay;
			else if (this.summaryList.cafeteriaSummaryTotalCard)
				this.summaryHeader = this.summaryList.cafeteriaSummaryTotalCard.fsaFrequencyDisplay;
		}

        this.showSummary = true;
    }

	public cancel(): void {
		this.emitCancel.emit();
	}

    public submitSummary() {
        this.emitComplete.emit();
    }
}